<template>
  <v-toolbar :fixed="true" style="z-index: 9999;">
    <v-toolbar-title>
      <a href="https://mindcarb.de/">
        <img
          :src="require('@/assets/logo.png')"
          :lazy-src="`@/assets/logo.png`"
          aspect-ratio="1"
          width="100"
        >
      </a>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat href="/tracking/overview" v-show="loggedIn">Verlaufsdaten</v-btn>
      <v-btn flat href="/motivation" v-show="loggedIn">Motivationsfragebogen</v-btn>
      <v-btn flat v-on:click="download" v-show="loggedIn && isAdmin">Datenexport</v-btn>
      <v-btn flat href="/users" v-show="loggedIn && isAdmin">Benutzerübersicht</v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            flat
            v-on="on"
            v-on:click="getTrainings()"
            v-show="loggedIn"
          >
            Kurse
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in trainingItems"
            :key="index"
          >
            <v-list-tile-title style="height: auto;">
              <v-btn flat v-bind:href="'/course/'+ item.key">{{ item.value }}</v-btn>
              </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            flat
            v-on="on"
            v-show="loggedIn"
          >
            Profil
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in profileItems"
            :key="index"
          >
            <v-list-tile-title style="height: auto;">
              <v-btn flat v-bind:href="item.link">{{ item.name }}</v-btn>
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn flat href="/login" v-show="!loggedIn">Anmeldung</v-btn>
      <v-btn flat v-show="loggedIn">
        <a href="https://mindcarb.de/#anchor-contact" style="color:rgba(0,0,0,.87); text-decoration: none" target="_blank"> Noch Fragen? </a>
      </v-btn>
      <v-btn flat href="/login" v-show="loggedIn">Abmelden</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { trainingService } from '../_services/training';
export default {
  data () {
    return {
      trainingItems: [],
      profileItems: [
        {name: 'Tracking Profil', link: '/profile'},
        {name: 'Passwort ändern', link: '/login/forgotpassword'}
      ]
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.authentication.status.loggedIn
    },
    isAdmin () {
      console.log(this.$store.state.authentication.status)
      return this.$store.state.authentication.status.role === 'admin'
    }
  },
  methods: {
    download () {
      const { dispatch } = this.$store
      dispatch('download/xlsx')
    },
    getTrainings () {
      trainingService.getTrainings()
      .then(
          response => {
            this.trainingItems = response.data
            if (this.trainingItems.length == 0) {
              this.trainingItems = this.$store.state.authentication.status.trainings;
            }
          },
          error => {
            console.log(error)
            this.errorPage = '<h1 style="padding:25px;">Das von Ihnen gesuchte Training konnte leider nicht gefunden werden.</h1>'
          }
        )
      }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/app/Navigation.vue